import { forwardRef, ReactNode } from "react";
import cx from "classnames";

import { Icon } from "../../Icon";
import { Flex, FlexProps } from "../../Flex";

import styles from "../Combobox.module.scss";
import listViewStyles from "../../ListView/ListView.module.scss";
import checkboxStyles from "../../Checkbox/Checkbox.module.scss";
import CheckboxOutline from "@servicetitan/hammer-icon/mdi/round/check_box_outline_blank.svg";
import CheckboxChecked from "@servicetitan/hammer-icon/mdi/round/check_box.svg";
import CheckboxIndeterminate from "@servicetitan/hammer-icon/mdi/round/indeterminate_check_box.svg";
import { PassThroughProps } from "../../../types";

export type ComboboxItemVisualProps = {
  children: ReactNode;
  rootDivProps: PassThroughProps<"div">;
  disabled: boolean;
  checked: boolean;
  hideCheckbox: boolean;
  flexProps?: FlexProps;
};

export const ComboboxItemVisual = forwardRef(
  (
    {
      children,
      disabled,
      checked,
      hideCheckbox,
      rootDivProps,
      flexProps,
    }: ComboboxItemVisualProps,
    ref: React.ForwardedRef<HTMLDivElement>,
  ) => {
    return (
      <div
        ref={ref}
        data-anv="combobox-item"
        {...rootDivProps}
        className={cx(
          styles["listview-option"],
          listViewStyles["listview-option"],
          rootDivProps.className,
        )}
      >
        {!hideCheckbox ? (
          <div className={cx(styles["cell"], listViewStyles["cell"])}>
            <div className={checkboxStyles["wrapper"]}>
              <div className={checkboxStyles["checkbox"]}>
                <input
                  type="checkbox"
                  checked={checked}
                  aria-checked={checked}
                  aria-label="Select"
                  readOnly
                  tabIndex={-1}
                  {...(disabled ? { disabled: true } : {})}
                />

                <span className={checkboxStyles["icon-wrapper"]} aria-hidden>
                  <Icon
                    size="large"
                    svg={CheckboxIndeterminate}
                    className={checkboxStyles["icon-indeterminate"]}
                  />

                  <Icon
                    size="large"
                    svg={CheckboxChecked}
                    className={checkboxStyles["icon-checked"]}
                  />

                  <Icon
                    size="large"
                    svg={CheckboxOutline}
                    className={checkboxStyles["icon-unchecked"]}
                  />
                </span>

                <span aria-hidden></span>
              </div>
            </div>
          </div>
        ) : null}
        <Flex grow={1} shrink={1} {...flexProps}>
          {children}
        </Flex>
      </div>
    );
  },
);

ComboboxItemVisual.displayName = "ComboboxItemVisual";
